export enum TaskActions {
  START = 'start',
  STOP = 'stop',
  CLOSE = 'close',
  REJECT = 'reject',
  CONFIRM_CLOSE = 'confirm_close', // used to perform "Confirm close" action in APP
  CONFIRM_REJECT = 'confirm_reject', // used to perform "Confirm reject" action in APP
  CONFIRM_CLOSE_AND_REJECT = 'confirm_close_and_reject', // Used to grant permissions as frontliner pro
}
